var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showModal)?_c('div',{staticClass:"modal"},[_c('div',{staticClass:"modal-content"},[_c('p',[_vm._v(_vm._s(_vm.message))]),_c('div',{staticClass:"modal-buttons"},[_c('button',{on:{"click":_vm.handleOk}},[_vm._v("Ok")]),_c('button',{on:{"click":_vm.handleCancel}},[_vm._v("Cancel")])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }